import { getYear } from "date-fns";
import { LinkAnchorButton } from "lib/miolo";
import Link from "next/link";
import * as React from "react";
import mediaQueries from "../../lib/utils/layout/mediaQueries";
import Fundamentei from "../branding/Fundamentei";
import * as palette from "../palette";

export default function Footer() {
  return (
    <footer
      css={mediaQueries({
        display: "grid",
        gridRowGap: 30,
        gridColumnGap: 30,
        gridTemplateColumns: ["1fr", "1fr", "1fr", "repeat(12, 1fr)"],
        justifyContent: "center",
        width: [null, null, null, "100%"],
        maxWidth: 1140,
        margin: "0px auto",
        padding: ["0px 30px", 0, 0, 0],
        textAlign: ["center", "center", "left"],
      })}
    >
      <div
        css={mediaQueries({
          display: "grid",
          gridRowGap: 48,
          gridColumn: [null, null, null, "span 10"],
          gridColumnGap: 48,
          gridTemplateColumns: ["100%", "100%", "repeat(4, max-content)", "repeat(4, max-content)"],
        })}
      >
        {/* A Empresa */}
        <div>
          <div
            css={{
              display: "grid",
              gridRowGap: 16,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 14,
                letterSpacing: 0.6,
                textTransform: "uppercase",
              }}
            >
              Links
            </h4>

            <div>
              <ul
                css={{
                  display: "grid",
                  gridRowGap: 16,
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                }}
              >
                <li>
                  <Link href="/premium">
                    <LinkAnchorButton
                      href="/premium"
                      style={{
                        color: palette.lynch,
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: 0.6,
                      }}
                    >
                      Premium
                    </LinkAnchorButton>
                  </Link>
                </li>

                <li>
                  <Link href="/fatos-relevantes">
                    <LinkAnchorButton
                      href="/fatos-relevantes"
                      style={{
                        color: palette.lynch,
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: 0.6,
                      }}
                    >
                      Fatos Relevantes
                    </LinkAnchorButton>
                  </Link>
                </li>

                <li>
                  <Link href="/events-calendar">
                    <LinkAnchorButton
                      href="/events-calendar"
                      style={{
                        color: palette.lynch,
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: 0.6,
                      }}
                    >
                      Agenda
                    </LinkAnchorButton>
                  </Link>
                </li>

                <li>
                  <LinkAnchorButton
                    href="mailto:contato@fundamentei.com"
                    style={{
                      color: palette.lynch,
                      fontWeight: 500,
                      fontSize: 14,
                      letterSpacing: 0.6,
                    }}
                  >
                    Contato
                  </LinkAnchorButton>
                </li>

                <li>
                  <Link href="/privacy">
                    <LinkAnchorButton
                      href="/privacy"
                      style={{
                        color: palette.lynch,
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: 0.6,
                      }}
                    >
                      Privacidade
                    </LinkAnchorButton>
                  </Link>
                </li>

                <li>
                  <Link href="/payments-and-refunds">
                    <LinkAnchorButton
                      href="/payments-and-refunds"
                      style={{
                        color: palette.lynch,
                        fontWeight: 500,
                        fontSize: 14,
                        letterSpacing: 0.6,
                      }}
                    >
                      Pagamentos & reembolsos
                    </LinkAnchorButton>
                  </Link>
                </li>

                <li>
                  <Link href="/terms">
                    <LinkAnchorButton
                      href="/terms"
                      style={{
                        fontSize: 14,
                        letterSpacing: 0.6,
                        color: palette.lynch,
                        fontWeight: 500,
                      }}
                    >
                      Termos de Uso
                    </LinkAnchorButton>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Links */}

        {/* A Empresa */}
        <div>
          <div
            css={{
              display: "grid",
              gridRowGap: 16,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 14,
                letterSpacing: 0.6,
                textTransform: "uppercase",
              }}
            >
              A Empresa
            </h4>

            <div>
              <ul
                css={{
                  display: "grid",
                  gridRowGap: 16,
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                }}
              >
                <li>
                  <LinkAnchorButton
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://medium.com/@fundamentei"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.6,
                      color: palette.lynch,
                      fontWeight: 500,
                    }}
                  >
                    Blog
                  </LinkAnchorButton>
                </li>

                <li>
                  <LinkAnchorButton
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://changelog.fundamentei.com"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.6,
                      color: palette.lynch,
                      fontWeight: 500,
                    }}
                  >
                    Novidades
                  </LinkAnchorButton>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* A Empresa */}

        {/* Desenvolvedores */}
        <div>
          <div
            css={{
              display: "grid",
              gridRowGap: 16,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 14,
                letterSpacing: 0.6,
                textTransform: "uppercase",
              }}
            >
              Desenvolvedores
            </h4>

            <div>
              <ul
                css={{
                  display: "grid",
                  gridRowGap: 16,
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                }}
              >
                <li>
                  <LinkAnchorButton
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/fundamentei"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.6,
                      color: palette.lynch,
                      fontWeight: 500,
                    }}
                  >
                    GitHub
                  </LinkAnchorButton>
                </li>

                <li>
                  <LinkAnchorButton
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://stackshare.io/fundamentei/fundamentei"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.6,
                      color: palette.lynch,
                      fontWeight: 500,
                    }}
                  >
                    StackShare
                  </LinkAnchorButton>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Desenvolvedores */}

        {/* Redes Sociais */}
        <div>
          <div
            css={{
              display: "grid",
              gridRowGap: 16,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 14,
                letterSpacing: 0.6,
                textTransform: "uppercase",
              }}
            >
              Nas Redes Sociais
            </h4>

            <div>
              <ul
                css={mediaQueries({
                  display: "grid",
                  gridRowGap: 24,
                  gridColumnGap: 24,
                  gridTemplateColumns: [
                    "repeat(3, max-content)",
                    "repeat(3, max-content)",
                    "repeat(3, max-content)",
                    "repeat(5, max-content)",
                  ],
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                })}
              >
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC72WcGU4HpVposjNHlP3FRg"
                    title="YouTube"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={{
                      color: palette.baliHai,
                      textDecoration: "none",
                      "&:hover": {
                        color: "#E93323",
                      },
                      "&:focus": {
                        color: "#E93323",
                        outline: "none",
                      },
                    }}
                  >
                    <YouTube />
                  </a>
                </li>

                <li>
                  <a
                    href="https://instagram.com/fundamentei"
                    title="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={{
                      color: palette.baliHai,
                      textDecoration: "none",
                      "&:hover": {
                        color: "#000000",
                      },
                      "&:focus": {
                        color: "#000000",
                        outline: "none",
                      },
                    }}
                  >
                    <Instagram />
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.facebook.com/consultoreduardocavalcanti"
                    title="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={{
                      color: palette.baliHai,
                      textDecoration: "none",
                      "&:hover": {
                        color: "#3878EA",
                      },
                      "&:focus": {
                        color: "#3878EA",
                        outline: "none",
                      },
                    }}
                  >
                    <Facebook />
                  </a>
                </li>

                <li>
                  <a
                    href="https://twitter.com/fundamentei"
                    title="Twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={{
                      color: palette.baliHai,
                      textDecoration: "none",
                      "&:hover": {
                        color: "#4DA0EB",
                      },
                      "&:focus": {
                        color: "#4DA0EB",
                        outline: "none",
                      },
                    }}
                  >
                    <Twitter />
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.linkedin.com/company/fundamentei"
                    title="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                    css={{
                      color: palette.baliHai,
                      textDecoration: "none",
                      "&:hover": {
                        color: "#3376B0",
                      },
                      "&:focus": {
                        color: "#3376B0",
                        outline: "none",
                      },
                    }}
                  >
                    <LinkedIn />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Redes Sociais */}
      </div>

      <div
        css={mediaQueries({
          gridColumn: [null, null, null, "span 2"],
        })}
      >
        <div
          css={{
            display: "grid",
            gridRowGap: 16,
            gridTemplateColumns: "1fr",
            textAlign: "center",
          }}
        >
          <Link href="/">
            <a
              href="/"
              aria-label="Página inicial"
              css={{
                color: palette.heather,
                "&:hover": {
                  color: palette.royalBlue,
                },
                "&:focus": {
                  outline: "none",
                },
              }}
            >
              <Fundamentei fill="currentColor" width={39} height={37} />
            </a>
          </Link>

          <div>
            <span
              css={{
                color: palette.baliHai,
                fontWeight: 500,
                fontSize: 14,
                letterSpacing: 0.6,
              }}
            >
              © {getYear(new Date())} Fundamentei
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function YouTube(props: React.SVGProps<any>) {
  return (
    <svg width={45} height={32} {...props}>
      <path
        fill="currentColor"
        d="M44.06 5.007c-.518-1.97-2.043-3.523-3.979-4.05C36.571 0 22.5 0 22.5 0S8.428 0 4.919.957c-1.936.527-3.461 2.08-3.979 4.05C0 8.579 0 16.032 0 16.032s0 7.453.94 11.026c.518 1.97 2.043 3.458 3.979 3.985C8.429 32 22.5 32 22.5 32s14.072 0 17.581-.957c1.936-.527 3.461-2.014 3.979-3.985.94-3.573.94-11.026.94-11.026s0-7.453-.94-11.025zM18 23V10l12 6.5L18 23z"
      />
    </svg>
  );
}

function Instagram(props: React.SVGProps<any>) {
  return (
    <svg width={32} height={32} {...props}>
      <path
        fill="currentColor"
        d="M16.004 7.796A8.19 8.19 0 007.8 16a8.19 8.19 0 008.203 8.204A8.19 8.19 0 0024.206 16a8.19 8.19 0 00-8.202-8.204zm0 13.538A5.343 5.343 0 0110.67 16a5.338 5.338 0 015.333-5.334A5.338 5.338 0 0121.336 16a5.343 5.343 0 01-5.332 5.334zM26.454 7.46a1.909 1.909 0 01-1.912 1.914 1.914 1.914 0 111.913-1.914zm5.434 1.942c-.122-2.563-.707-4.834-2.585-6.705C27.433.827 25.163.241 22.6.112c-2.641-.15-10.559-.15-13.2 0C6.844.234 4.574.82 2.697 2.69.819 4.561.24 6.832.112 9.395c-.15 2.642-.15 10.56 0 13.203.122 2.563.707 4.834 2.585 6.705 1.877 1.87 4.14 2.456 6.703 2.585 2.641.15 10.559.15 13.2 0 2.563-.122 4.833-.707 6.703-2.585 1.87-1.871 2.456-4.142 2.585-6.705.15-2.642.15-10.554 0-13.196zm-3.413 16.03a5.4 5.4 0 01-3.041 3.042c-2.106.836-7.103.643-9.43.643-2.328 0-7.332.186-9.43-.643a5.4 5.4 0 01-3.042-3.041c-.835-2.107-.643-7.105-.643-9.433 0-2.328-.185-7.333.643-9.433a5.4 5.4 0 013.041-3.041c2.106-.836 7.103-.643 9.43-.643 2.328 0 7.332-.186 9.431.643a5.4 5.4 0 013.041 3.041c.835 2.107.643 7.105.643 9.433 0 2.328.192 7.333-.643 9.433z"
      />
    </svg>
  );
}

function Facebook(props: React.SVGProps<any>) {
  return (
    <svg width={32} height={32} {...props}>
      <path
        fill="currentColor"
        d="M32 16.097C32 7.205 24.839 0 16 0S0 7.205 0 16.097C0 24.132 5.851 30.791 13.5 32V20.75H9.435v-4.653H13.5v-3.546c0-4.034 2.387-6.263 6.043-6.263 1.751 0 3.582.315 3.582.315v3.959h-2.018c-1.987 0-2.607 1.241-2.607 2.514v3.021h4.437l-.71 4.654H18.5V32C26.149 30.791 32 24.132 32 16.097z"
      />
    </svg>
  );
}

function Twitter(props: React.SVGProps<any>) {
  return (
    <svg width={32} height={32} {...props}>
      <path
        fill="currentColor"
        d="M28.571 0H3.43A3.43 3.43 0 000 3.429V28.57A3.43 3.43 0 003.429 32H28.57A3.43 3.43 0 0032 28.571V3.43A3.43 3.43 0 0028.571 0zM25.08 11.343c.014.2.014.407.014.607 0 6.193-4.714 13.329-13.329 13.329-2.657 0-5.121-.772-7.193-2.1a9.87 9.87 0 001.129.057 9.392 9.392 0 005.814-2 4.69 4.69 0 01-4.378-3.25c.721.107 1.371.107 2.114-.086a4.685 4.685 0 01-3.75-4.6v-.057c.621.35 1.35.564 2.114.593a4.675 4.675 0 01-2.085-3.9c0-.872.228-1.672.635-2.365a13.302 13.302 0 009.657 4.9c-.664-3.178 1.715-5.757 4.572-5.757 1.35 0 2.564.565 3.421 1.479a9.18 9.18 0 002.972-1.129 4.672 4.672 0 01-2.057 2.579 9.323 9.323 0 002.7-.729 9.86 9.86 0 01-2.35 2.429z"
      />
    </svg>
  );
}

function LinkedIn(props: React.SVGProps<any>) {
  return (
    <svg width={32} height={32} {...props}>
      <path
        fill="currentColor"
        d="M29.714 0H2.28C1.02 0 0 1.036 0 2.307v27.386C0 30.964 1.021 32 2.279 32h27.435C30.971 32 32 30.964 32 29.693V2.307C32 1.036 30.971 0 29.714 0zM9.671 27.429H4.93V12.157h4.75V27.43H9.67zM7.3 10.07a2.751 2.751 0 010-5.5 2.756 2.756 0 012.75 2.75 2.747 2.747 0 01-2.75 2.75zM27.45 27.43h-4.743V20c0-1.771-.036-4.05-2.464-4.05-2.472 0-2.85 1.929-2.85 3.921v7.558H12.65V12.157h4.55v2.086h.064c.636-1.2 2.186-2.464 4.493-2.464 4.8 0 5.693 3.164 5.693 7.278v8.372z"
        fillRule="nonzero"
      />
    </svg>
  );
}
